<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs pt-5>
        <v-layout row wrap justify-center align-center>
          <v-flex xs11 lg11>
            <h2>{{ $t("Toolbar.announceList") }}</h2>
          </v-flex>
        </v-layout>
        <v-layout row wrap fill-height justify-center pt-5>
          <v-flex xs11 lg11>
            <v-card class="rounded-lg">
              <v-card-title primary-title>
                {{ $t("AnnounceList.Title") }}
              </v-card-title>
              <v-card-text class="pa-2">
                <v-layout row wrap justify-center ma-0 pa-2>
                  <v-flex xs11 sm11 md2 lg2 pa-2>
                    <v-card
                      class="colorCardGreen rounded-lg elevation-0"
                      @click="Fn_ShowDataConsent('All')"
                    >
                      <v-card-text
                        class="pa-2 text-center"
                        style="color: #077893"
                      >
                        <b> {{ $t("AnnounceList.AllData") }} </b>
                        <div class="mt-3">
                          <span>
                            <b class="mt-3" style="font-size: 40px">
                              {{ ItemCount.count_all }}</b
                            >
                            {{ $t("consentlist.list") }}</span
                          >
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs11 sm11 md2 lg2 pa-2>
                    <v-card
                      class="colorCard rounded-lg elevation-0"
                      @click="Fn_ShowDataConsent('WAIT')"
                    >
                      <v-card-text
                        class="pa-2 text-center"
                        style="color: #ffb300"
                      >
                        <b> {{ $t("AnnounceList.WaitData") }} </b>
                        <div class="mt-3">
                          <span>
                            <b class="mt-3" style="font-size: 40px">
                              {{ ItemCount.count_wait }}</b
                            >
                            {{ $t("consentlist.list") }}</span
                          >
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs11 sm11 md2 lg2 pa-2>
                    <v-card
                      class="colorPurple rounded-lg elevation-0"
                      @click="Fn_ShowDataConsent('Read')"
                    >
                      <v-card-text
                        class="pa-2 text-center"
                        style="color: #0040ff"
                      >
                        <b>
                          {{ $t("onechat.status5") }}
                        </b>
                        <div class="mt-3">
                          <span>
                            <b class="mt-3" style="font-size: 40px">
                              {{ ItemCount.count_read }}</b
                            >
                            {{ $t("consentlist.list") }}</span
                          >
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs11 sm11 md2 lg2 pa-2>
                    <v-card
                      class="colorCardRed rounded-lg elevation-0"
                      @click="Fn_ShowDataConsent('ER')"
                    >
                      <v-card-text class="pa-2 text-center red--text">
                        <b> {{ $t("AnnounceList.ErrorSendData") }} </b>
                        <div class="mt-3">
                          <span>
                            <b class="mt-3" style="font-size: 40px">
                              {{ ItemCount.count_er }}</b
                            >
                            {{ $t("consentlist.list") }}</span
                          >
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs11 sm11 md2 lg2 pa-2>
                    <v-card
                      class="colorWhiteGreen rounded-lg elevation-0"
                      @click="Fn_ShowDataConsent('OK')"
                    >
                      <v-card-text
                        class="pa-2 text-center"
                        style="color: green"
                      >
                        <b>{{ $t("AnnounceList.AgreeData") }} </b>
                        <div class="mt-3">
                          <span>
                            <b class="mt-3" style="font-size: 40px">
                              {{ ItemCount.count_ok }}</b
                            >
                            {{ $t("consentlist.list") }}</span
                          >
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
                <v-card class="elevation-0">
                  <v-card-text style="max-height: 800px; overflow: auto">
                    <v-timeline
                      align-top
                      dense
                      v-for="(item, i) in ItemAnnounce"
                      :key="i"
                    >
                      <v-timeline-item :color="ColorTimeLine" small>
                        <v-card class="elevation-5">
                          <v-card-text>
                            <v-layout
                              row
                              wrap
                              justify-center
                              align-center
                              mt-n4
                            >
                              <v-flex xs11 sm11 md12 lg12 mb-5>
                                <strong>{{ item.AnnounceName }}</strong>
                              </v-flex>
                            </v-layout>
                            <v-layout row wrap justify-center>
                              <v-flex
                                xs11
                                sm11
                                md4
                                lg4
                                v-if="$t('default') === 'th'"
                              >
                                {{ $t("consentlist.organization") }}:
                                {{ item.BusinessNameTh }}
                              </v-flex>
                              <v-flex xs11 sm11 md4 lg4 v-else>
                                {{ $t("consentlist.organization") }}:
                                {{ item.BusinessNameEng }}
                              </v-flex>
                              <v-flex
                                xs11
                                sm11
                                md3
                                lg3
                                v-if="$t('default') === 'th'"
                              >
                                ผู้ขอ: {{ item.ReqNameTh }}
                              </v-flex>
                              <v-flex xs11 sm11 md3 lg3 v-else>
                                Requester: {{ item.ReqNameEng }}
                              </v-flex>
                              <v-flex
                                xs11
                                sm11
                                md4
                                lg4
                                v-if="$t('default') === 'th'"
                              >
                                วันที่สร้าง: {{ item.CreatedAt }}
                              </v-flex>
                              <v-flex xs11 sm11 md4 lg4 v-else>
                                Create date: {{ item.CreatedAtEng }}
                              </v-flex>

                              <v-flex
                                xs11
                                sm11
                                md1
                                lg1
                                v-if="ItemCount.count_ok"
                              >
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      small
                                      v-bind="attrs"
                                      v-on="on"
                                      dark
                                      color="#077893"
                                      fab
                                      @click="Fn_ViewDetail(item)"
                                    >
                                      <v-icon
                                        >mdi-text-box-search-outline</v-icon
                                      ></v-btn
                                    > </template
                                  ><span>{{ $t("consentlist.detail") }}</span>
                                </v-tooltip>
                              </v-flex>
                              <v-flex xs11 sm11 md1 lg1 v-else>
                                <v-menu offset-y>
                                  <template v-slot:activator="{ attrs, on }">
                                    <v-btn
                                      dark
                                      v-bind="attrs"
                                      v-on="on"
                                      small
                                      class="mx-2"
                                      fab
                                      color="#077893"
                                    >
                                      <v-icon dark size="20">
                                        mdi-format-list-bulleted-square
                                      </v-icon>
                                    </v-btn>
                                  </template>

                                  <v-list
                                    v-for="(list, i) in itemsAction"
                                    :key="i"
                                    dense
                                  >
                                    <v-list-item
                                      @click="
                                        fn_checkActionType(list.service, item)
                                      "
                                      link
                                    >
                                      <v-list-item-icon class="mr-3">
                                        <v-icon :color="list.color"
                                          >{{ list.icon }}
                                        </v-icon>
                                      </v-list-item-icon>
                                      <v-list-item-title
                                        v-if="$t('default') === 'th'"
                                        :inner-text.prop="list.text"
                                        style="font-size: 14px"
                                      ></v-list-item-title>
                                      <v-list-item-title
                                        v-else
                                        :inner-text.prop="list.text2"
                                        style="font-size: 14px"
                                      ></v-list-item-title>
                                    </v-list-item>
                                  </v-list>
                                </v-menu>
                              </v-flex>
                              <v-flex xs11 sm11 md11 lg12 text-left>
                                <v-tooltip top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                      v-bind="attrs"
                                      color="#077893"
                                      style="cursor: pointer"
                                      small
                                      @click="Fn_CopyDetail(item.AnnounceId)"
                                      v-on="on"
                                      >mdi-file-multiple-outline</v-icon
                                    >
                                  </template>
                                  <span>{{ $t("consentlist.copy") }}</span>
                                </v-tooltip>
                                {{ $t("consentlist.did") }}
                                {{ item.AnnounceId }}
                              </v-flex>
                            </v-layout>
                          </v-card-text>
                        </v-card>
                      </v-timeline-item>
                    </v-timeline>
                  </v-card-text>
                </v-card>
              </v-card-text>
              <div v-if="loadingDownloadData">
                <OverlaySearch />
              </div>
              <DialogDetail
                :item="ItemView"
                :show="DialogDetail"
                @closeDialog="DialogDetail = false"
                @reData="Fn_GetDataAnnounce"
              />
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import DialogDetail from "@/components/dialog/Announce/DialogDetailAnnounceList.vue";
import OverlaySearch from "@/components/layouts/LoadingPage.vue";
import authorization from "@/functions/authorization.js";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import { mapGetters } from "vuex";

const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: {
    OverlaySearch,
    DialogDetail,
  },
  data: (vm) => ({
    TypeStatus: "All",
    ItemAnnounce: [],
    ItemCount: [],
    ItemView: [],
    loadingDownloadData: false,
    ColorTimeLine: "#077893",
    itemsAction: [
      {
        icon: "mdi-text-box-search-outline",
        text: "ดูรายละเอียด",
        text2: "Details",
        color: "success",
        service: "View",
      },
      {
        icon: "mdi-send-circle-outline",
        text: "ส่งประกาศ",
        text2: "Send Announcement",
        color: "info",
        service: "Petition",
      },
    ],
    DialogPetitionRequest: false,
    DialogDetailPetition: false,
    DialogDetail: false,
    DialogGroupDetailEmail: false,
    DialogGroupDetailOnePlatform: false,
    DialogGeneralDetailOnePlatform: false,
    detail: "",
    Tag: [],
    GetTypeRequest: [],
    DataCheckCancel: [],
  }),
  computed: {
    ...mapGetters(["DataGeneralConsent"]),
    ...mapGetters(["Business"]),
    ...mapGetters(["RoleAccount"]),

    _SendId: {
      get() {
        return this.DataGeneralConsent.SendId || "-";
      },
    },
  },
  mounted() {
    this.Fn_GetDataAnnounce();
  },
  methods: {
    async Fn_GetDataAnnounce() {
      this.loadingDownloadData = true;
      this.ItemCount = [];
      this.ItemAnnounce = [];
      var payload = {
        AccountId: this.$cookies.get("OneAccountId"),
        BusinessId: this.$cookies.get("BusinessId"),
        Status: this.TypeStatus,
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "business/ListAnnounce",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.ItemCount = response.data.Message.Count[0];
            this.ItemAnnounce = response.data.Message.Announce;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    fn_checkActionType(val, item) {
      if (val == "View") {
        this.Fn_ViewDetail(item);
      } else if (val == "Petition") {
        this.Fn_SendAnnounce(item);
      }
    },
    async Fn_ViewDetail(item) {
      this.ItemView = item;
      this.DialogDetail = true;
    },
    async Fn_SendAnnounce(item) {
      this.loadingDownloadData = true;
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccessToken: this.$cookies.get("OneAccessToken"),
        AnnounceId: item.AnnounceId,
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "onechat/OnePlatform/ReSendAnnounce",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            if (response.data.Message.Status === "ER") {
              Toast.fire({
                icon: "error",
                title: response.data.Message.ErrorMessage,
              });
            } else {
              Toast.fire({
                icon: "success",
                title: this.$t("NewUpdate.announ5"),
              });
            }
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },

    Fn_ShowDataConsent(val) {
      this.TypeStatus = "";
      this.ColorTimeLine = "";
      if (val === "All") {
        this.TypeStatus = val;
        this.ColorTimeLine = "#077893";
        this.Fn_GetDataAnnounce();
      }
      if (val === "WAIT") {
        this.TypeStatus = val;
        this.ColorTimeLine = "#ffb300";
        this.Fn_GetDataAnnounce();
      } else if (val === "Read") {
        this.TypeStatus = val;
        this.ColorTimeLine = "#0040ff";
        this.Fn_GetDataAnnounce();
      } else if (val === "ER") {
        this.TypeStatus = val;
        this.ColorTimeLine = "red";
        this.Fn_GetDataAnnounce();
      } else if (val === "OK") {
        this.TypeStatus = val;
        this.ColorTimeLine = "green";
        this.Fn_GetDataAnnounce();
      }
    },
    async Fn_CopyDetail(val) {
      await navigator.clipboard.writeText(val);
    },
  },
};
</script>

<style scoped>
td {
  border-style: hidden !important;
}

input#input-70 {
  cursor: pointer !important;
}
.colorCard {
  background: #fef4da;
}
.colorCardGreen {
  background: #c9f3fd;
}
.colorCardRed {
  background: rgb(255, 224, 224);
}
.colorPurple {
  background: #d2ddff;
}
.colorWhiteGreen {
  background: rgb(213, 250, 213);
}
.bg-color {
  background-color: #ddf7ff;
}
</style>
